import axios from "axios";
import { useEffect, useState } from "react";
import { getLocal, getSession } from "../utils/localStorage.utils";
const token = getLocal('token') || getSession('token')

const hostname = window.location.hostname;
let APP_BASE_URL = process.env.REACT_APP_API_ENDPOINT;
switch(hostname) {
    case "admintrial.trialclouds.com":
        APP_BASE_URL = process.env.REACT_APP_API_ENDPOINT_TRIALCLOUDS;
        break;
    case "adminff.ffshopbd.com":
        APP_BASE_URL = process.env.REACT_APP_API_ENDPOINT_FFSHOPBD;
        break;
    default:
            
}

function useGet(urlToFetch, baseURL, refresh) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!urlToFetch) return false;
    setLoading(true);
    setError(false)
    setTimeout(() => {
      axios({
        baseURL: baseURL || APP_BASE_URL,
        timeout: 10000,
        headers: {
          authorization: token
        },
        method: "GET",
        url: urlToFetch
      }).then((res) => {
        const data = res.data.data || res.data
        setData(data);
        setLoading(false);
      })
        .catch((err) => {
          setError(err);
          setLoading(false);
        });
    }, 400);

  }, [urlToFetch, baseURL, refresh]);
  return [data, loading, error];
}

export default useGet;
